//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CreditCardMetaData } from './CreditCardMetaData';
import { PaymentProcessorType, PaymentProcessorState } from './Enums';

export class PaymentProcessorDisplayItem extends ItemBase {
    ID: string | null = null;
    Type: PaymentProcessorType = PaymentProcessorType.PayPalPro;
    AccountID: string | null = null;
    AutoPaySupported: boolean = false;
    StoredPaymentMethodsSupported: boolean = false;
    State: PaymentProcessorState = PaymentProcessorState.Inactive;
    Default: boolean = false;
    MinimumCharge: number = 0;
    CurrencyMultiplier: number = 0;
    CreditCardsMetaData: CreditCardMetaData[] = [];     // OBSOLETE - Use only for compatibility

    constructor(initializer?: Partial<PaymentProcessorDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PaymentProcessorDisplayItem";
}
